import {useTheme} from "next-themes";

export type ColorMode = "light" | "dark";

export interface UseColorModeReturn {
  colorMode: ColorMode;
  setColorMode: (colorMode: ColorMode) => void;
  toggleColorMode: () => void;
}

export function useColorMode(): UseColorModeReturn {
  const {resolvedTheme, setTheme} = useTheme();
  const toggleColorMode = () => {
    setTheme(resolvedTheme === "light" ? "dark" : "light");
  };
  return {colorMode: resolvedTheme as ColorMode, setColorMode: setTheme, toggleColorMode};
}

export function useColorModeValue<T>(light: T, dark: T) {
  const {colorMode} = useColorMode();
  return colorMode === "dark" ? dark : light;
}
